import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import {
    EditorRetargetingRateCorrectionCondition,
    RateControlValue,
    RateCorrectionConditionChooserItemsGroup,
    RateCorrectionConditionId,
    RateCorrectionType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';
import { RateCorrectionConditionChooserView } from '../../RateCorrectionConditionChooser/RateCorrectionConditionChooser';
import { RateCorrectionConditionSelector } from '../../RateCorrectionConditionSelector/RateCorrectionConditionSelector';

import './RatesCorrectionsListRetargetingCondition.css';

export type onChangeRetargetingConditionParams = {
    type: RateCorrectionType.retargeting;
    value: EditorRetargetingRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListRetargetingConditionProps {
    value: EditorRetargetingRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    isDisabled: boolean;
    chooserData: Array<RateCorrectionConditionChooserItemsGroup>;
    disabledChooserDataItems: Array<RateCorrectionConditionId>;
    isChooserDisabled: boolean;
    onChange: (params: onChangeRetargetingConditionParams) => void;
}

const blockClass = 'rates-corrections-list-retargeting-condition';

export class RatesCorrectionsListRetargetingCondition extends React.PureComponent<
    RatesCorrectionsListRetargetingConditionProps
> {
    render() {
        const {
            chooserData,
            isDisabled,
            minRate,
            maxRate,
            value,
            disabledChooserDataItems,
            isChooserDisabled
        } = this.props;

        return (
            <div className={blockClass}>
                <RateCorrectionConditionSelector
                    cls={Bem.cls(blockClass, 'selector')}
                    view={RateCorrectionConditionChooserView.default}
                    value={[value.retargetingConditionId]}
                    isDisabled={isDisabled || isChooserDisabled}
                    items={chooserData}
                    disabledItems={disabledChooserDataItems}
                    hideDisabledItems={true}
                    onChange={this.onRateCorrectionConditionChooserChange}
                />

                <RateControl
                    value={value.value}
                    max={maxRate}
                    min={minRate}
                    isDisabled={isDisabled}
                    isCommon={false}
                    errors={value.errors.value}
                    onChange={this.onRateControlChange}
                />
            </div>
        );
    }

    private onRateCorrectionConditionChooserChange = (values: Array<string>) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.retargeting,
            id: value.id,
            value: {
                ...value,
                retargetingConditionId: values[0]
            }
        });
    };

    private onRateControlChange = (rate: RateControlValue) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.retargeting,
            id: value.id,
            value: {
                ...value,
                value: rate
            }
        });
    };
}
